"use client";

import { StateCreator } from "zustand";
// import { ISinglePatientEnrollment } from "../components/testData/patientEnrollment";

export type PatientPathState = {
  // selectedPatientEnrollment: ISinglePatientEnrollment | null; // will change later
  patientType: string;
  unenrollPatient: boolean;
  queryString: string;
  surgeonFilter: string[];

  // Actions
  // setSelectedPatientEnrollment: (
  //   patient: ISinglePatientEnrollment | null
  // ) => void;
  setPatientType: (type: string) => void;
  setUnenrollPatient: (unenroll: boolean) => void;
  setQueryString: (q: string | undefined) => void;
  setSurgeonFilter: (surgeons: string[] | undefined) => void;
};

// states used on monthly page
export const createPatientPathSlice: StateCreator<PatientPathState> = (
  set
) => ({
  // selectedPatientEnrollment: null,
  patientType: "",
  unenrollPatient: false,
  queryString: "",
  surgeonFilter: [],

  // Actions
  // setSelectedPatientEnrollment: (patient) =>
  //   set({ selectedPatientEnrollment: patient }),
  setPatientType: (type) => set({ patientType: type }),
  setUnenrollPatient: (unenroll) => set({ unenrollPatient: unenroll }),
  setQueryString: (q) => set({ queryString: q }),
  setSurgeonFilter: (surgeons) => set({ surgeonFilter: surgeons }),
});
